import { useIntl } from 'react-intl';
import { Box, IconButton, Typography } from '@mui/material';
import InfoIconActive from '@mui/icons-material/Info';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import {
  METRICS_EXPAND_MESSAGING_VIEW,
  METRICS_COLLAPSE_MESSAGING_VIEW,
  useAnalytics,
} from '@xolv-mybrightlink/common';
import { useCallback } from 'react';

type MessageBarHeaderProps = {
  infoIsOpen?: boolean;
  toggleInfo: () => void;
  toggleMode: () => void;
  standalone?: boolean;
  showInfoIcon: boolean;
};

export const MessageBarHeader = (props: MessageBarHeaderProps) => {
  const intl = useIntl();
  const analytics = useAnalytics();
  const expandStyle = !props.standalone
    ? { bgcolor: '#d6e5f9', borderRadius: 2 }
    : null;
  const toggleMode = useCallback(() => {
    const action = props.standalone
      ? METRICS_EXPAND_MESSAGING_VIEW
      : METRICS_COLLAPSE_MESSAGING_VIEW;
    analytics.trackAction(action);
    props.toggleMode();
  }, [analytics, props]);

  return (
    <Box display='flex' alignItems='center' margin='0 20px 0 20px'>
      <Box flex={1} display='flex' alignItems='center'>
        <Typography fontSize={20} fontWeight={500}>
          {intl.formatMessage({ id: 'messages' })}
        </Typography>
        {props.showInfoIcon && (
          <IconButton onClick={props.toggleInfo}>
            {props.infoIsOpen ? (
              <InfoIconActive color='primary' />
            ) : (
              <InfoIcon />
            )}
          </IconButton>
        )}
      </Box>
      <IconButton onClick={toggleMode} sx={expandStyle}>
        <img src='/public/assets/icons/ic_expand_care_team.svg' alt='Expand' />
      </IconButton>
    </Box>
  );
};
